import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import ContactForm from './OtherContact';
const ContactModal = (props) => {
  const { viewState, setViewState, resetField, saveContact } = props;

  const onModalClose = () => {
    setViewState({ show: false });
    resetField(false);
  };

  const modalHeader = {
    derOwner: 'DER Owner Details',
    secCust: 'Secondary Customer Details',
    poiOwner: 'Point Of Interconnection Property Owner Details'
  };

  return (
    <Modal
      centered
      size="xl"
      show={viewState.show}
      onHide={onModalClose}
      closeButton
      backdrop="static"
    >
      <Modal.Header closeButton>
        <h6>{modalHeader[viewState.type]}</h6>
      </Modal.Header>
      <Modal.Body>
        <ContactForm
          type={viewState.type}
          formData={viewState?.data}
          setSection={() => {}}
          pageType={viewState.mode === 'view' ? 'view' : 'edit'}
          showCommonForm={true}
          saveContact={saveContact}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ContactModal;
